export const getImageSrcSet = (
  imageData: any,
  format: 'image/avif' | 'image/webp' = 'image/webp'
): string | undefined => {
  const fromSource = imageData?.images?.sources?.find(
    (source: { type: string }) => source.type === format
  )?.srcSet

  if (fromSource) {
    return fromSource
  }

  if (format === 'image/webp') {
    return imageData?.images?.fallback?.srcSet
  }

  return undefined
}

export const pickSrcFromSrcSet = (
  srcSet: string | undefined,
  targetWidth: number
): string | null => {
  if (!srcSet) {
    return null
  }

  const candidates = srcSet
    .split(',')
    .map((part) => {
      const [url, descriptor] = part.trim().split(/\s+/)
      const width = parseInt(descriptor?.replace('w', ''), 10)

      if (!url || Number.isNaN(width)) {
        return null
      }

      return { url, width }
    })
    .filter(Boolean) as Array<{ url: string; width: number }>

  if (!candidates.length) {
    return null
  }

  candidates.sort((a, b) => a.width - b.width)

  return (
    candidates.find((candidate) => candidate.width >= targetWidth)?.url ??
    candidates[candidates.length - 1].url
  )
}
